class RegionChangeModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this;
    this.isoCods = this?.modal?.dataset?.isoCods;
    this.localizationCountryIsoOnLoad = this.modal.dataset.currentMarketCountry;
    this.differentCountryTitle = this.modal.querySelector('.modal-linguage-switcher__title-different-country');
    this.sameCountryTitle = this.modal.querySelector('.modal-linguage-switcher__title-same-country');
    this.clientCountryObject = null;
    this.isSwitcherAlreadyInited = false

    //Buttons
    this.submitBtn = document.querySelector('.modal-linguage-switcher__submit-btn');
    this.cancelBtn = document.querySelector('.modal-linguage-switcher__cancel-btn');
    this.closeBtn = document.querySelector('.modal-linguage-switcher__close-btn');
    this.allRegionsBtn = document.querySelector('.modal-linguage-switcher__all-regions-btn');
    this.closeDesktopBtn = document.querySelector('.modal-linguage-switcher__close-btn--desktop');
    this.closeBtnSwitcher = document.querySelector('.modal-linguage-switcher__close-btn-switcher');
    this.regionButtons = document.querySelectorAll('.modal-linguage-switcher__one-region-button');

    // ellements
    this.disclosureToggle = document.querySelectorAll('.disclosure__toggle');
    this.goBackBtn = document.querySelector('.country-switcher__go-back-btn');
    this.closeLogoBtn = document.querySelector('.modal-linguage-switcher__close-btn');
    this.disclosureToggle = document.querySelectorAll('.disclosure__toggle');
    this.countryInput = document.querySelector('.modal-linguage-switcher__country-input');
    this.languageInput = document.querySelector('.modal-linguage-switcher__language-input');
    this.searchInputs = document.querySelectorAll('#modal-linguage-switcher__search-input');
    this.backdrop = document.querySelector('.modal-linguage-switcher-backdrop');

    //containers
    this.oneRegionContainer = document.querySelector('.modal-linguage-switcher__one-region');
    this.allRegionsContainer = document.querySelector('.modal-linguage-switcher__all-regions');
    this.regionContainers = document.querySelectorAll('.country-switcher__region');

    // form
    this.countryForm = this.modal.querySelector('form');
  }

  connectedCallback() {
    const isoCods = this.getIsoCods();
    const isComDomain = this.isComDomain();
    const countryInsideLocalStorage = this.getCountryInsideLocalStorage();

    const assignMainLogick = async () => {
      const clientCountry = await this.getClientCountry();

      const needToRedirect = this.needToRedirect(isoCods, isComDomain, this.localizationCountryIsoOnLoad, clientCountry);

      if (needToRedirect) {
        const cleanUrl = this.urlCleaner(window.location.href);
        const urlFromApi = await this.getUrlFromApi(cleanUrl, clientCountry);

        this.showModal();
        this.changeTextContent('[data-redirect-country]', clientCountry);
        this.toggleTitle(clientCountry);
        this.initRedirectionButton(clientCountry, urlFromApi);
        this.initCancelButton(this.localizationCountryIsoOnLoad)
        this.initCloseButton();
        if (!this.isSwitcherAlreadyInited) {
          this.isSwitcherAlreadyInited = true;
          this.initSwitcher(isoCods);
        }

        document.addEventListener('keydown', this.closeByEscape);
      }
    }

    if (!countryInsideLocalStorage) {
      assignMainLogick();
    }

    if (countryInsideLocalStorage) {
      this.closeBtnSwitcher.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
        this.saveChangeMarketCountryToCookie(this.localizationCountryIsoOnLoad);
      });
    }

    // this.initDropdowns()
    this.initRegionButtons()

    this.allRegionsBtn.addEventListener('click', () => this.openModal(isoCods));
    this.disclosureToggle.forEach(item => {
      item.addEventListener('click', () => this.openSwitcher(isoCods));
    })
    this.goBackBtn.addEventListener('click', () => {
      this.closeModal();
      this.saveChangeMarketCountryToCookie(this.localizationCountryIsoOnLoad);
    })
  }

  initRegionButtons() {
    const allRegionsTabs = this.querySelectorAll('.country-switcher__region');

    this.regionButtons.forEach(button => {
      button.addEventListener('click', () => {

        allRegionsTabs.forEach(tab => {
          tab.classList.remove('active');
        });

        this.regionButtons.forEach(button => {
          button.classList.remove('active');
        });

        button.classList.add('active');

        const regionIndex = Number(button.dataset.regionIndex) + 1;

        allRegionsTabs[String(regionIndex)]?.classList.add('active');

      })
    });
  }

  openSwitcher = (isoCods) => {
    if (!this.isSwitcherAlreadyInited) {
      this.isSwitcherAlreadyInited = true;
      this.initSwitcher(isoCods)
    }

    this.modal.style.display = 'flex'
    this.oneRegionContainer.style.transition = 'all 0.3s ease-in-out';
    this.oneRegionContainer.style.overflow = 'hidden';
    this.oneRegionContainer.style.transform = 'scale(0)';
    this.oneRegionContainer.style.opacity = '0';
    this.modal.style.borderRadius = '0';
    this.oneRegionContainer.style.display = 'none';
    this.allRegionsContainer.style.display = 'block';
    this.allRegionsContainer.style.transition = 'all 0.3s ease-in-out';
    this.allRegionsContainer.style.overflow = 'visible';
    this.allRegionsContainer.style.transform = 'scale(1)';
    this.allRegionsContainer.style.opacity = '1';
    this.modal.style.transition = 'all 0.3s ease-in-out';
    this.modal.style.width = '100vw';
    this.modal.style.height = '100vh';
    this.backdrop.style.display = 'flex';
    this.closeDesktopBtn.style.display = 'none';

    document.addEventListener('keydown', this.closeByEscape);
  }

  getIsoCods() {
    let isoCods = JSON.parse(this.isoCods);

    if (!isoCods) {
      console.log(isoCods, '<<<<<====== isoCods is empty, please check your settings and add iso_cods metaobject');
      isoCods = [];
    }

    if (isoCods) {
      isoCods.forEach(isoCod => {
        if (isoCod.title) {
          const country = isoCod.title;
          const obj = arrayWithData.find(item => {
            if (item[country.toLowerCase()]) {
              return item;
            }
          })
          if (obj) {
            obj[country.toLowerCase()].external_url = isoCod.url;
          }
        }
      });
    }

    return isoCods;
  }

  openModal = (isoCods) => {
    if (!this.isSwitcherAlreadyInited) {
      this.isSwitcherAlreadyInited = true;
      this.initSwitcher(isoCods)
    }

    this.oneRegionContainer.style.transition = 'all 0.3s ease-in-out';
    this.oneRegionContainer.style.overflow = 'hidden';
    this.oneRegionContainer.style.transform = 'scale(0)';
    this.oneRegionContainer.style.opacity = '0';
    this.modal.style.borderRadius = '0';
    this.backdrop.style.display = 'flex';
    this.closeDesktopBtn.style.display = 'none';
    setTimeout(() => {
      this.oneRegionContainer.style.display = 'none';
      this.allRegionsContainer.style.display = 'block';
      this.allRegionsContainer.style.transition = 'all 0.3s ease-in-out';
      this.allRegionsContainer.style.overflow = 'visible';
      this.allRegionsContainer.style.transform = 'scale(1)';
      this.allRegionsContainer.style.opacity = '1';
      this.modal.style.transition = 'all 0.3s ease-in-out';
      this.modal.style.width = '100vw';
      this.modal.style.height = '100vh';

    }, 300);
  }

  initSwitcher = async (isoCods) => {
    // show loader
    this.showLoader();

    try {
      const allCountries = this.allRegionsContainer.querySelectorAll('.country-switcher__item');
      const cleanUrl = this.urlCleaner(window.location.href);
      const urlsFromApi = await this.getAllUrlsFromApi(cleanUrl);

      if (!allCountries) {
        this.hideLoader();
        return;
      }

      this.initSearchInput(allCountries);

      const initCountryClick = (e, link) => {
        e.preventDefault();
        e.stopPropagation();
        const value = e.currentTarget?.dataset.value;
        const language = e.currentTarget?.dataset.language;

        // this.updateCountryObject(value);
        this.changeMarketCountry(value, language, link);
        return false;
      }

      allCountries.forEach(country => {
        if (country.dataset.withoutLanguages) {
          return;
        }
        const links = country.querySelectorAll('.country-switcher__item-link');

        // Обрабатываем каждую ссылку в стране
        links.forEach(link => {
          const obj = isoCods.find(item => item.title.toLowerCase() === link.dataset.value.toLowerCase())
          let finalUrl
          if (obj) {
            const currentPageExternalUrl = JSON.parse(urlsFromApi)[link.dataset.value] || JSON.parse(urlsFromApi).usa;
            const serverUrl = new URL(currentPageExternalUrl);
            const pathname = serverUrl.pathname;

            if (obj.sufix_only_lang) {
              if (link.dataset.language != 'en') {
                // Специальное условие для .ch домена с немецким языком
                if (obj.url.includes('.ch') && link.dataset.language === 'de') {
                  finalUrl = `${obj.url}${pathname}`
                } else if (obj.url.includes('.be') && link.dataset.language === 'nl') {
                  finalUrl = `${obj.url}${pathname}`
                } else {
                  finalUrl = `${obj.url}/${link.dataset.language}${pathname}`
                }
              } else {
                finalUrl = `${obj.url}${pathname}`
              }
            }

            if (!obj.redirect_with_prefixes) {
              finalUrl = `${obj.url}${pathname}`

              if (obj?.title?.toUpperCase() === 'DE' && obj.url === 'https://goodevas.de' && link.dataset.language === 'en') {
                finalUrl = `${obj.url}/${link.dataset.language}${pathname}`
              }
            } else {
              if (!obj.sufix_only_lang) {
                // Special condition for .ch domain with German language
                if (obj.url.includes('.ch') && link.dataset.language === 'de') {
                  finalUrl = `${obj.url}${pathname}`
                } else {
                  finalUrl = `${obj.url}/${link.dataset.language}-${link.dataset.value}${pathname}`
                }
              }
            }

            // Every branch above rebuilds the URL from obj.url + pathname, which
            // drops the query the API deliberately kept (discount, ref, utm_*).
            // Re-attach it here so one line covers all of them.
            if (finalUrl) finalUrl += serverUrl.search;

            link.href = finalUrl
          }

          // Добавляем обработчик клика для каждой ссылки
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            initCountryClick(e, link);
          });
        });
      });

      const otherCountries = document.querySelectorAll('.country-switcher__item-link--other-countries');

      if (otherCountries.length > 0) {
        otherCountries.forEach(countryDef => {
          countryDef.addEventListener('click', () => {
            window.location.href = 'https://guodevas.com/';
          });
        });
      }

      // hide loader
      this.hideLoader();
    } catch (error) {
      console.error('Error in initSwitcher:', error);
      this.hideLoader();
    }
  }

  changeMarketCountry(value, language, link) {
    const isoCods = this.getIsoCods();
    const isIsoCodsIncludeValue = isoCods.findIndex(isoCod => isoCod.title.toLowerCase() === value.toLowerCase()) !== -1;

    if (isIsoCodsIncludeValue) {
      window.location.href = link;
      this.saveChangeMarketCountryToCookie(value);
      this.closeModal();
    } else {
      this.countryForm.querySelector('input[name="country_code"]').value = value;
      if (language) {
        this.countryForm.querySelector('input[name="language_code"]').value = language;
      }
      this.saveChangeMarketCountryToCookie(value);
      this.closeModal();
      this.countryForm.submit();
    }
  }

  updateCountryObject(value) {
    if (arrayWithData.length > 0) {
      const foundItem = arrayWithData.find(item => {

        return item[value];
      });
      if (foundItem) {
        this.clientCountryObject = foundItem[value];
      }
    }
  }

  initSearchInput(allCountries) {
    this.searchInputs.forEach(input => {
      input.addEventListener('input', (e) => {
        this.openDropdown(e.target.value.toLowerCase());
      });
    })
  }

    openDropdown(value) {
      const searchContainer = document.querySelector('.country-switcher__region-99');
      const linksArray = [];
      const addedItems = new Set(); // For tracking already added items

      // If search is empty, hide search container and show regular regions
      if (value === '') {
        searchContainer.classList.remove('active');
        searchContainer.innerHTML = '';

        // Return to first tab (North America)
        this.regionButtons.forEach(button => {
          button.classList.remove('active');
        });
        this.regionContainers.forEach(container => {
          container.classList.remove('active');
        });

        // Activate first button and first region
        if (this.regionButtons[0]) {
          this.regionButtons[0].classList.add('active');
        }
        if (this.regionContainers[1]) {
          this.regionContainers[1].classList.add('active');
        }

        return;
     }

     this.regionContainers.forEach(container => {
      this.regionButtons.forEach(button => {
        button.classList.remove('active');
      });
      container.classList.remove('active');

      const links = container.querySelectorAll('.country-switcher__item-link');
      const regionList = container.querySelector('.country-switcher__region-list');
      const items = container.querySelectorAll('.country-switcher__item');

      items.forEach(item => {
        const title = item.querySelector('.country-switcher__item-region-name');

        if (!title || !title.textContent) return;

        if (title.textContent.toLowerCase().includes(value)) {
          // Check if this item was already added
          const itemId = title.textContent.toLowerCase();
          if (!addedItems.has(itemId)) {
            addedItems.add(itemId);
            linksArray.push(item);
          }
        }
      });
    });

     searchContainer.innerHTML = '';

     linksArray.forEach(item => {
       const itemCopy = item.cloneNode(true);

       const linksInCopy = itemCopy.querySelectorAll('.country-switcher__item-link');
       linksInCopy.forEach(linkElement => {
         linkElement.addEventListener('click', (e) => {
           e.preventDefault();
           e.stopPropagation();
           const value = e.currentTarget.dataset.value;
           const language = e.currentTarget.dataset.language;

           this.changeMarketCountry(value, language, e.currentTarget);
           return false;
         });
       });

       searchContainer.appendChild(itemCopy);
     });

    searchContainer.classList.add('active');

  }

  toggleTitle(clientCountry) {
    if (clientCountry.toLowerCase() === this.localizationCountryIsoOnLoad.toLowerCase()) {
      this.differentCountryTitle.style.display = 'none'
      this.sameCountryTitle.style.display = 'block'
    }
  }

  initCloseButton() {
    this.closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeModal();
      this.saveChangeMarketCountryToCookie(this.localizationCountryIsoOnLoad);
    });

    this.closeBtnSwitcher.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeModal();
      this.saveChangeMarketCountryToCookie(this.localizationCountryIsoOnLoad);
    });
  }

  closeByEscape = (e) => {
    if (e.key === 'Escape') {
      this.closeModal();
      this.saveChangeMarketCountryToCookie(this.localizationCountryIsoOnLoad);
    }

    document.removeEventListener('keydown', this.closeByEscape);
  }

  getCountryInsideLocalStorage() {
    return this.getCountryFromCookie();
  }

  initCancelButton(isoCode) {
    this.cancelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.saveChangeMarketCountryToCookie(isoCode);
      this.closeModal();
    });
  }

  initRedirectionButton(clientCountry, urlFromApi) {
    this.submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.saveChangeMarketCountryToCookie(clientCountry);
      this.closeModal();

      window.location.href = urlFromApi;
    });
  }

  saveChangeMarketCountryToCookie(country) {
    const object = {
      country: country || 'us',
      timeStamp: Date.now(),
    };

    // remove domain from cookie
    document.cookie = `marketCountry=${JSON.stringify(object)}; path=/; max-age=${60*60*24*30}; SameSite=Lax`;
  }

  getCountryFromCookie() {
    const cookies = document.cookie.split(';');
    const marketCountryCookie = cookies.find(cookie =>
      cookie.trim().startsWith('marketCountry=')
    );

    if (marketCountryCookie) {
      try {
        const marketCountryObject = JSON.parse(marketCountryCookie.split('=')[1]);
        const currentTimeStamp = Date.now();
        const marketCountryTimeStamp = marketCountryObject.timeStamp;
        const timeDifference = currentTimeStamp - marketCountryTimeStamp;

        if (timeDifference > 1000 * 60 * 60 * 24 * 30) { // 30 days
          document.cookie = 'marketCountry=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
          return null;
        }

        return marketCountryObject.country;
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  getAllUrlsFromApi(cleanUrl) {
    return fetch(`https://switcher-app.fly.dev/api/get-link?link=${encodeURIComponent(cleanUrl)}&region=all`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(data => {
      return data;
    })
    .catch(error => {
      console.log('Error fetching url from api:', error);
      return 'Error';
    });
  }


  getUrlFromApi(cleanUrl, clientCountry) {
    return fetch(`https://switcher-app.fly.dev/api/get-link?link=${encodeURIComponent(cleanUrl)}&region=${clientCountry}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(data => {
      return data;
    })
    .catch(error => {
      console.log('Error fetching url from api:', error);
      return 'Error';
    });
  }

  urlCleaner(url) {
    if (url) {
      const currentUrl = url;
      const urlObj = new URL(currentUrl);
      const pathname = urlObj.pathname;

      const cleanPathname = pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/');

      // Query params are passed through untouched: the switcher backend decides
      // what to keep, drop or rewrite for the target store.
      const cleanUrl = `${urlObj.protocol}//${urlObj.hostname}${cleanPathname}${urlObj.search}${urlObj.hash}`;
      return cleanUrl
    }
  }

  isComDomain() {
    const currentDomain = window.location.hostname;
    const isComDomain = currentDomain.endsWith('.com');
    return isComDomain;
  }

  getClientCountry() {
    return fetch('https://ipinfo.io/json')
      .then(response => response.json())
      .then(data => {
        const localizationCountryIsoFromFetch = data.country.toLowerCase();
        return localizationCountryIsoFromFetch;
      })
      .catch(error => {
        console.log('Error fetching country:', error);
        return 'Error';
      });
  }

  needToRedirect(isoCods, isComDomain, localizationCountryIsoOnLoad, countryIsoCode) {
    const isCountryInsideIsoCodes = isoCods.findIndex(item => item.title.toLowerCase() === countryIsoCode.toLowerCase()) !== -1;

    if (isCountryInsideIsoCodes) {
      return true;
    }
    return false;
  } 

  closeModal() {
    this.modal.style.display = 'none';
    this.backdrop.style.display = 'none';
  }

       showModal() {
     this.modal.style.display = 'flex';
     this.backdrop.style.display = 'flex';
   }

   showLoader() {
     const loader = this.allRegionsContainer.querySelector('.country-switcher__loader');
     if (loader) {
       loader.style.display = 'flex';
     }
   }

   hideLoader() {
     const loader = this.allRegionsContainer.querySelector('.country-switcher__loader');
     if (loader) {
       loader.style.display = 'none';
     }
   }

  changeTextContent(selector, text) {
    const obj = arrayWithData.find(item => {
      if (item[text.toLowerCase()]) {
        return item;
      }
    })

    const countryName = obj[text]?.countryname

    if (countryName) {
      const element = document.querySelectorAll(selector);
      element.forEach(item => {
        item.textContent = this.capitalizeFirstLetter(countryName);
      })
    }
  }

  capitalizeFirstLetter(string) {
    if (!string) return string;

    return string[0].toUpperCase() + string.slice(1);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('region-change-modal', RegionChangeModal);
});

const arrayWithData = [
  {
    al: {
      countryname: "albania",
      countryisocode: "al",
    }
  },
  {
    au: {
      countryname: "australia",
      countryisocode: "au",
    }
  },
  {
    at: {
      countryname: "austria",
      countryisocode: "at",
    }
  },
  {
    bh: {
      countryname: "bahrain",
      countryisocode: "bh",
    }
  },
  {
    be: {
      countryname: "belgium",
      countryisocode: "be",
    }
  },
  {
    br: {
      countryname: "brazil",
      countryisocode: "br",
    }
  },
  {
    bg: {
      countryname: "bulgaria",
      countryisocode: "bg",
    }
  },
  {
    ca: {
      countryname: "canada",
      countryisocode: "ca",
    }
  },
  {
    cl: {
      countryname: "chile",
      countryisocode: "cl",
    }
  },
  {
    cn: {
      countryname: "china",
      countryisocode: "cn",
    }
  },
  {
    hr: {
      countryname: "croatia",
      countryisocode: "hr",
    }
  },
  {
    cy: {
      countryname: "cyprus",
      countryisocode: "cy",
    }
  },
  {
    cz: {
      countryname: "czechia",
      countryisocode: "cz",
    }
  },
  {
    dk: {
      countryname: "denmark",
      countryisocode: "dk",
    }
  },
  {
    ee: {
      countryname: "estonia",
      countryisocode: "ee"
    }
  },
  {
    fi: {
      countryname: "finland",
      countryisocode: "fi"
    }
  },
  {
    fr: {
      countryname: "france",
      countryisocode: "fr"
    }
  },
  {
    ge: {
      countryname: "georgia",
      countryisocode: "ge"
    }
  },
  {
    de: {
      countryname: "germany",
      countryisocode: "de"
    }
  },
  {
    gr: {
      countryname: "greece",
      countryisocode: "gr"  
    }
  },
  {
    hk: {
      countryname: "hong kong sar",
      countryisocode: "hk",
    }
  },
  {
    hu: {
      countryname: "hungary",
      countryisocode: "hu",
    }
  },
  {
    is: {
      countryname: "iceland",
      countryisocode: "is",
    }
  },
  {
    in: {
      countryname: "india",
      countryisocode: "in",
    }
  },
  {
    ie: {
      countryname: "ireland",
      countryisocode: "ie",
    }
  },
  {
    im: {
      countryname: "isle of man",
      countryisocode: "im",
    }
  },
  {
    il: {
      countryname: "israel",
      countryisocode: "il",
    }
  },
  {
    it: {
      countryname: "italy",
      countryisocode: "it",
    }
  },
  {
    jp: {
      countryname: "japan",
      countryisocode: "jp",
    }
  },
  {
    je: {
      countryname: "jersey",
      countryisocode: "je",
    }
  },
  {
    jo: {
      countryname: "jordan",
      countryisocode: "jo",
    }
  },
  {
    kw: {
      countryname: "kuwait",
      countryisocode: "kw",
    }
  },
  {
    lv: {
      countryname: "latvia",
      countryisocode: "lv",
    }
  },
  {
    li: {
      countryname: "liechtenstein",
      countryisocode: "li",
    }
  },
  {
    lt: {
      countryname: "lithuania",
      countryisocode: "lt",
    }
  },
  {
    lu: {
      countryname: "luxembourg",
      countryisocode: "lu",
    }
  },
  {
    my: {
      countryname: "malaysia",
      countryisocode: "my",
    }
  },
  {
    mt: {
      countryname: "malta",
      countryisocode: "mt",
    }
  },
  {
    mq: {
      countryname: "martinique",
      countryisocode: "mq",
    }
  },
  {
    nl: {
      countryname: "netherlands",
      countryisocode: "nl",
    }
  },
  {
    mk: {
      countryname: "north macedonia",
      countryisocode: "mk",
    }
  },
  {
    no: {
      countryname: "norway",
      countryisocode: "no",
    }
  },
  {
    pe: {
      countryname: "peru",
      countryisocode: "pe",
    }
  },
  {
    ph: {
      countryname: "philippines",
      countryisocode: "ph",
    }
  },
  {
    pl: {
      countryname: "poland",
      countryisocode: "pl",
    }
  },
  {
    pt: {
      countryname: "portugal",
      countryisocode: "pt",
    }
  },
  {
    qa: {
      countryname: "qatar",
      countryisocode: "qa",
    }
  },
  {
    ro: {
      countryname: "romania",
      countryisocode: "ro",
    }
  },
  {
    sa: {
      countryname: "saudi arabia",
      countryisocode: "sa",

    }
  },
  {
    rs: {
      countryname: "serbia",
      countryisocode: "rs"
    }
  },
  {
    sg: {
      countryname: "singapore",
      countryisocode: "sg",
    }
  },
  {
    sk: {
      countryname: "slovakia",
      countryisocode: "sk",
    }
  },
  {
    si: {
      countryname: "slovenia",
      countryisocode: "si",
    }
  },
  {
    kr: {
      countryname: "south korea",
      countryisocode: "kr",
    }
  },
  {
    es: {
      countryname: "spain",
      countryisocode: "es",
    }
  },
  {
    sj: {
      countryname: "svalbard & jan mayen",
      countryisocode: "sj",

    }
  },
  {
    se: {
      countryname: "sweden",
      countryisocode: "se",
    }
  },
  {
    ch: {
      countryname: "switzerland",
      countryisocode: "ch",
    }
  },
  {
    tw: {
      countryname: "taiwan",
      countryisocode: "tw",
    }
  },
  {
    th: {
      countryname: "thailand",
      countryisocode: "th",

    }
  },
  {
    tr: {
      countryname: "türkiye",
      countryisocode: "tr"
    }
  },
  {
    ua: {
      countryname: "ukraine",
      countryisocode: "ua"
    }
  },
  {
    ae: {
      countryname: "united arab emirates",
      countryisocode: "ae"
    }
  },
  {
    gb: {
      countryname: "united kingdom",
      countryisocode: "gb"
    }
  },
  {
    us: {
      countryname: "united states",
      countryisocode: "us"
    }
  },
  {
    vn: {
      countryname: "vietnam",
      countryisocode: "vn"
    }
  },
  {
    jp: {
      countryname: "Japan",
      countryisocode: "jp"
    }
  }
];
